import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.m,

      padding: SPACES.xxxxl,
      minWidth: 300,

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 32px)',
      },
      [theme.breakpoints.up('tablet')]: {
        maxWidth: 600,
      },
    },
  },
}))
